import { collection, getDocs } from 'firebase/firestore';
import { db } from '../firebase';

export const getFailedTopUpCount = async () => {
    try {
        const snapshot = await getDocs(collection(db, 'transactions'));
        const successful = snapshot.docs.filter(doc => {
            const data = doc.data();
            const status = data.status;
            
            // Check for "success" status (case-insensitive)
            return typeof status === 'string' && status.toLowerCase() != 'success';
        });
        
        console.log(`Found ${successful.length} successful transactions`);
        return successful.length;
    } catch (error) {
        console.error('Error getting successful top-up count:', error);
        return 0;
    }
};
